/**
 * The app shell a route renders inside, selected per route via `meta.layout` and
 * resolved at navigation time by `AppLayoutRoot`.
 *
 * This module must stay a leaf: **do not add imports to it.** Route modules read
 * `Layout` at module-evaluation time, inside their route record literals, so the
 * enum has to be initialised before any route module runs. The barrel
 * (`@/core/layout`) re-exports both this enum and `AppLayoutRoot`, and that
 * component eagerly pulls in the header, the sidebar and the stores behind them —
 * a subgraph that reaches back into `@/router`. Route modules therefore import
 * from this file directly rather than from the barrel; anything imported here
 * would re-open that cycle and leave `Layout` undefined.
 */
export enum Layout {
    /**
     * Renders only the route's content, with no header, sidebar, or other app chrome.
     */
    Blank = 'blank',

    /**
     * Full app shell: header plus a collapsible navigation sidebar. This is the
     * default layout for authenticated app pages.
     */
    Sidebar = 'sidebar',

    /**
     * App shell with a header but no navigation sidebar.
     */
    HeaderOnly = 'header-only',
}
